import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AttendancendAssignmentStatus from "./Widgets/AttendancendAssignmentStatus";
import LeaderBoardndPercentile from "./Widgets/LeaderBoardndPercentile";
import Scores from "./Widgets/Scores";
import MainDropDown from "./Widgets/WidgetMenu/MainDropDown";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import Popup from "../../CommonComponents/Popup";
import constant from "../../../constants";
import { manipulateForTables } from "./Widgets/WidgetMenu/DownloadOptions";
import Button from "../../Button";
import constants from "../../../constants";
import ModuleHooks from "../../../Hooks/ModuleHooks";
import ExportToCsv from "./ExportToCsv";
import IconButton from "../../CommonComponents/IconButton";
import Tooltip from "../../CommonComponents/Tooltip";

function AdminDashBoard() {
  const axios = useAxiosPrivate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [widgetsMetaData, setWidgetsMetaData] = useState([]);
  const [showDashboardDropDown, setShowDashboardDropDown] = useState(false);
  const {
    currentDashboardMetaData,
    isAdmin,
    setDbStatus,
    setIsUnAuth,
    setIsDashBoardEdit,
    isCommonPopup,
    setShowNotify,
  } = useContext(AlertContext);
  const [refreshDashboard, setRefreshDashboard] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const { clearPopupStates } = ModuleHooks();
  const navigate = useNavigate();
  const { downloadExcel } = ExportToCsv();
  const ref = useRef(null);

  useEffect(() => {
    setWidgetsMetaData([]);
    setIsPublished(currentDashboardMetaData.boardDetails[0].status === 2);
    if (Object.keys(currentDashboardMetaData).length !== 0) {
      setDescription(currentDashboardMetaData?.boardDetails[0]?.description);
      setName(currentDashboardMetaData?.boardDetails[0]?.name);
      let widgetData = currentDashboardMetaData?.widgets?.map((item) => {
        return {
          wid: item.id,
          type: item.widget_id,
          ordero: item.orderno,
          name: item.name,
          description: item.description,
        };
      });
      setWidgetsMetaData(widgetData);
    }
  }, [currentDashboardMetaData]);

  useEffect(() => {
    console.log("isPublished--------->", isPublished);
  }, [isPublished]);

  const handleCloseResponsePopup = (id) => {
    clearPopupStates();
    setIsDashBoardEdit(false);
  };

  const handleWarningResponsePopupClose = () => {
    clearPopupStates();
  };

  async function getWidgetData(item) {
    let responseOfwidgetData = await axios.get(
      `node/admin/dashboard/${currentDashboardMetaData?.boardDetails[0].id}/widget/${item.wid}/report`,
      {
        params: {
          type: item.type,
        },
        headers: {
          "Content-type": "application/json",
        },
      }
    );

    return responseOfwidgetData;
  }

  const downloadAllWidgets = async () => {
    setIsDownloading(true);
    let parentArray = [];
    let orientationArray = [];
    let widgetNameArray = [];
    for (let i = 0; i < widgetsMetaData.length; i++) {
      widgetNameArray.push(widgetsMetaData[i].name);
      let parentArrayresponse = await getWidgetData(widgetsMetaData[i]);
      let manipulatedData = await manipulateForTables(
        widgetsMetaData[i].type,
        parentArrayresponse?.data?.data?.data,
        parentArrayresponse?.data?.data?.headers
      );
      parentArray.push(manipulatedData);
      orientationArray.push(parentArrayresponse?.data?.data?.orientation);
    }

    //parentArrayresponse?.data?.data?.orientation
    let FormatArray = [];
    for (let i = 0; i < parentArray.length; i++) {
      // let currorientation ="landscape";
      let currFormat = "a1";
      if (
        parentArray[i][0].hasOwnProperty("percentile") ||
        parentArray[i][0].hasOwnProperty("ranking")
      ) {
        // currorientation="portrait";
        currFormat = "a4";
      }
      // orientationArray.push(currorientation);
      FormatArray.push(currFormat);
    }
    let dashBoardname = currentDashboardMetaData?.boardDetails[0]?.name;
    // generatePDF(
    //   parentArray,
    //   orientationArray,
    //   FormatArray,
    //   dashBoardname,
    //   widgetNameArray
    // );
    downloadExcel(parentArray, widgetNameArray, dashBoardname);
    setIsDownloading(false);
  };

  const handleBackBtn = () => {
    navigate("/dashboards");
  };

  const handleResponse = (title, msg, dId) => {
    setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  const handlePublishDashboard = async () => {
    try {
      const response = await axios.patch(
        "node/admin/dashboard/" +
          currentDashboardMetaData?.boardDetails[0].id +
          "/status",
        { status: constants.BOARD_STATUS.PUBLISHED },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setDbStatus(2);
      setIsPublished(true);
      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        handleResponse("Success", response.data.msg);
      } else {
        handleResponse("Warning", response.data.msg);
      }
    } catch (err) {
      if (err.message.includes("403")) {
        handleResponse(
          "Error",
          "You have been logged-out due to inactivity. Login again."
        );
        setIsUnAuth(true);
      } else {
        handleResponse("Error", err.message);
      }
    }
  };

  console.log("widgetsMetaData ", widgetsMetaData);

  return (
    <div className="mainAdminDashboard">
      {isCommonPopup && (
        <div className="popup-overlay">
          <Popup />
        </div>
      )}
      <div className="dashboardBack">
        {/* <span onClick={handleBackBtn}>
          <AngleLeftSvg /> Back
        </span> */}
        <Button
          size="sm"
          icon={{
            nospace: true,
            type: "leading",
            icon: (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 15L7.5 10L12.5 5"
                  stroke="#667085"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ),
          }}
          hierarchy={{
            type: "linkGrey",
            buttonText: "Back",
          }}
          onClick={handleBackBtn}
        />
        {!isPublished && (
          <Button
            size="sm"
            hierarchy={{ type: "primary", buttonText: "Publish" }}
            onClick={handlePublishDashboard}
          />
        )}
      </div>
      <div className="adminDashboardHeader">
        <div className="adminDashboardNamendDescription">
          <text id="adminDashboardText1"> {name}</text>
          <text id="adminDashboardText2"> {description}</text>
        </div>
        {isDownloading && (
          <span className="infoMessageDownload">
            Download in Progress, Please Wait....
          </span>
        )}
        <div className="maindashboardOptions">
          <Tooltip title="Download" isIcon={true}>
            <IconButton
              size="sm"
              onClick={downloadAllWidgets}
              hierarchy="tertiaryGrey"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"
                  stroke="#344054"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </Tooltip>
          <Tooltip title="Refresh" isIcon={true}>
            <IconButton
              hierarchy="tertiaryGrey"
              onClick={() => setRefreshDashboard(true)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.1666 3.33333V8.33333M19.1666 8.33333H14.1666M19.1666 8.33333L15.2999 4.7C14.4043 3.80392 13.2963 3.14934 12.0792 2.79731C10.8622 2.44528 9.57584 2.40729 8.34016 2.68688C7.10447 2.96647 5.95975 3.55452 5.01281 4.39618C4.06586 5.23783 3.34756 6.30565 2.92492 7.5M0.833252 16.6667V11.6667M0.833252 11.6667H5.83325M0.833252 11.6667L4.69992 15.3C5.59554 16.1961 6.70356 16.8507 7.92059 17.2027C9.13762 17.5547 10.424 17.5927 11.6597 17.3131C12.8954 17.0335 14.0401 16.4455 14.987 15.6038C15.934 14.7622 16.6523 13.6943 17.0749 12.5"
                  stroke="#344054"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </Tooltip>
          {isAdmin && (
            <div>
              <IconButton
                hierarchy="tertiaryGrey"
                onClick={() => {
                  setShowDashboardDropDown(!showDashboardDropDown);
                }}
                id="adminDashboardMenuIcon"
                aria-controls={
                  showDashboardDropDown ? "grouped-menu" : undefined
                }
                aria-haspopup="true"
                aria-expanded={showDashboardDropDown ? "true" : undefined}
                ref={ref}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.75 5C8.75 4.66848 8.8817 4.35054 9.11612 4.11612C9.35054 3.8817 9.66848 3.75 10 3.75C10.3315 3.75 10.6495 3.8817 10.8839 4.11612C11.1183 4.35054 11.25 4.66848 11.25 5C11.25 5.33152 11.1183 5.64946 10.8839 5.88388C10.6495 6.1183 10.3315 6.25 10 6.25C9.66848 6.25 9.35054 6.1183 9.11612 5.88388C8.8817 5.64946 8.75 5.33152 8.75 5ZM8.75 10C8.75 9.66848 8.8817 9.35054 9.11612 9.11612C9.35054 8.8817 9.66848 8.75 10 8.75C10.3315 8.75 10.6495 8.8817 10.8839 9.11612C11.1183 9.35054 11.25 9.66848 11.25 10C11.25 10.3315 11.1183 10.6495 10.8839 10.8839C10.6495 11.1183 10.3315 11.25 10 11.25C9.66848 11.25 9.35054 11.1183 9.11612 10.8839C8.8817 10.6495 8.75 10.3315 8.75 10ZM8.75 15C8.75 14.6685 8.8817 14.3505 9.11612 14.1161C9.35054 13.8817 9.66848 13.75 10 13.75C10.3315 13.75 10.6495 13.8817 10.8839 14.1161C11.1183 14.3505 11.25 14.6685 11.25 15C11.25 15.3315 11.1183 15.6495 10.8839 15.8839C10.6495 16.1183 10.3315 16.25 10 16.25C9.66848 16.25 9.35054 16.1183 9.11612 15.8839C8.8817 15.6495 8.75 15.3315 8.75 15Z"
                    fill="#344054"
                  />
                </svg>
              </IconButton>
              <MainDropDown
                showDashboardDropDown={showDashboardDropDown}
                setShowDashboardDropDown={setShowDashboardDropDown}
                data={currentDashboardMetaData.boardDetails[0]}
                anchorEl={ref}
              />
            </div>
          )}
        </div>
      </div>
      <div className="dashboardContent">
        {widgetsMetaData.map((i, ind) => (
          <>
            {(i.type == constant.BOARD_WIDGETS.ATTENDANCE  ||
              i.type == constant.BOARD_WIDGETS.ASSIGNMENT_STATUS ) && (
              <AttendancendAssignmentStatus
                name={name}
                setRefresh={setRefreshDashboard}
                refresh={refreshDashboard}
                data={widgetsMetaData[ind]}
                dashboardId={currentDashboardMetaData.boardDetails[0].id}
              />
            )}
            {(i.type == constant.BOARD_WIDGETS.PERCENTILE ||
              i.type == constant.BOARD_WIDGETS.LEADERBOARD) && (
              <LeaderBoardndPercentile
                name={name}
                setRefresh={setRefreshDashboard}
                refresh={refreshDashboard}
                data={widgetsMetaData[ind]}
                dashboardId={currentDashboardMetaData.boardDetails[0].id}
              />
            )}
            {i.type == constant.BOARD_WIDGETS.SCORES && (
              <Scores
                name={name}
                setRefresh={setRefreshDashboard}
                data={widgetsMetaData[ind]}
                refresh={refreshDashboard}
                dashboardId={currentDashboardMetaData.boardDetails[0].id}
              />
            )}
          </>
        ))}
      </div>
    </div>
  );
}

export default AdminDashBoard;
